/**
 * BugList — the board's summary rows: id · title · status pill.
 *
 * Story: epic-uat-portal-001-11.
 *
 * Each row is a button (keyboard-reachable, not a bare clickable div) that calls
 * `onSelect(id)` so the page can open the detail modal. The row renders only the
 * three member-safe summary fields; nothing else from the payload is in scope
 * here (the service already projected it).
 */

import type { MemberSafeBug } from '@/services/bugBoardService';
import { StatusPill } from './StatusPill';

interface BugListProps {
  bugs: MemberSafeBug[];
  onSelect: (id: string) => void;
}

export function BugList({ bugs, onSelect }: BugListProps) {
  return (
    <ul data-testid="board-list" className="flex flex-col gap-2">
      {bugs.map((bug) => (
        <li key={bug.id}>
          <button
            type="button"
            data-testid="board-row"
            onClick={() => onSelect(bug.id)}
            className="flex w-full items-center gap-4 rounded border border-gray-200 px-4 py-3 text-left hover:border-green-400 hover:bg-green-50"
          >
            <span
              data-testid="board-row-id"
              className="shrink-0 font-mono text-xs text-muted-foreground"
            >
              {bug.id}
            </span>
            <span data-testid="board-row-title" className="flex-1 text-sm font-medium">
              {bug.title}
            </span>
            <StatusPill status={bug.status} />
          </button>
        </li>
      ))}
    </ul>
  );
}
